import { styled } from 'styled-components';
import { DROPDOWN_CONTAINER_WIDTH } from './DropdownFilter.constants';

export const DropdownContainer = styled.div`
  position: relative;

  &.${DROPDOWN_CONTAINER_WIDTH.NARROW} {
    min-width: 8.125rem;
  }

  &.${DROPDOWN_CONTAINER_WIDTH.DEFAULT} {
    min-width: 13.75rem;
  }

  &.${DROPDOWN_CONTAINER_WIDTH.WIDE} {
    min-width: 18.75rem;
  }

  &.${DROPDOWN_CONTAINER_WIDTH.EXTRA_WIDE} {
    min-width: 28.125rem;
  }
`;

export const StyledOption = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledSecondaryLabel = styled.span`
  margin: 0 ${({ theme }) => theme.sizing.medium} 0;
`;

export const StyledOptionWithIconBody = styled.div`
  align-items: center;
  display: flex;
  gap: ${({ theme }) => theme.sizing.small};
`;

export const DropdownOverride = styled.div`
  label {
    padding-bottom: ${({ theme }) => theme.sizing.small};
  }
`;
